import PanelSelect from './panelSelect';
import CancelSelect from './cancelSelect';
import SingleSelect from './singleSelect';
import CtrlSelect from './ctrlSelect';
import ShiftSelect from './shiftSelect';
import SelectAll from './selectAll';
import SelectByRect from './selectByRect';
import CabinetColSelect from './cabinetColSelect';

function init(): void {
    // 面板选择事件
    PanelSelect.init();

    // 取消选择
    CancelSelect.init();

    // 单选
    SingleSelect.init();

    // ctrl选择
    CtrlSelect.init();

    // shift 选择
    ShiftSelect.init();

    // 全选
    SelectAll.init();

    // 框选
    SelectByRect.init();

    // 卧柜列选择
    CabinetColSelect.init();
}

export default {
    init
};
